export const READY = "ready"; // first update after initialization
export const MEDIA = "media"; // media query / breakpoint crossed event
export const RESIZE = "resize"; // resize event
export const SCROLL = "scroll"; // scroll event
export const ORIENTATION = "orientationchange"; // dual orientation change event
